<template>
  <component
    :is="tag"
    v-bind="$attrs"
    class="yt-pill"
    :class="{ _disabled: disabled }"
    @click="$emit('click')"
  >
    <span class="yt-pill__text font-text u-decor">
      <slot />
    </span>
    <slide-toggle dimension="width">
      <span
        v-if="removable && !disabled"
        class="yt-pill__icon u-flex-shrink-0 u-clickable"
        @click="$emit('remove')"
      >
        <span class="yt-pill__icon-container">
          <svg-inline tag="span" class="u-decor u-stroke-deep-current">
            <icon icon="close-circle-fill" />
          </svg-inline>
        </span>
      </span>
    </slide-toggle>
  </component>
</template>

<script>
import SlideToggle from "@/components/ui-kit/slide-toggle/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

export default {
  inheritAttrs: false,
  components: {
    SlideToggle,
    SvgInline,
    Icon,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    removable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
$b: ".yt-pill";

#{$b} {
  @include mixin.truncate-text();
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  max-width: 100%;
  padding: 6px;
  color: var.$green-main;
  background-color: currentColor;
  border: none;
  border-radius: 50px;
  outline: none;
  touch-action: manipulation;
  transition: var.$transition-fast;

  &:hover {
    color: var.$green-hover;
  }

  &:active {
    color: var.$green-dark;
    transition-duration: 0s;
  }

  &:disabled,
  &._disabled {
    color: var.$gray-hover;
    pointer-events: none;

    #{$b}__text {
      color: var.$secondary;
    }
  }

  &__text {
    font-family: var.$font-family-sf-pro-text;
    color: var.$white;
    margin: 0 4px;
  }

  &__icon {
    &-container {
      display: block;
      width: 16px;
    }
  }
}
</style>
